$(function() {

  /**
   * エラー項目が入力されたらエラー表示をしない。
   */
  var formTextareaError = (function() {
    var className = 'sw-FormTextarea-error';
    var check = (function() {
      $('.' + className).on('keyup', function() {
        if($(this).val().length > 0) {
          $(this).removeClass(className);
        } else {
          $(this).addClass(className);
        }
      });
    })();
  })();

}());
